import { Fade, useMediaQuery, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { useRef } from "react";
import Section from "../components/Section";
import { useIsVisible } from "../hooks/useIsVisible";
import bottomEffect from "../images/NewUI/bottom_effect.png";
import eco1 from "../images/NewUI/eco1.png";
import eco2 from "../images/NewUI/eco2.png";
import WhiteGradientButton from "./WhiteGradientButton";

const EcosystemSection = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const ref = useRef();
  const isVisible = useIsVisible(ref);

  return (
    <>
      <Section pt={md ? "" : 4} pb="0" className="p-relative">
        <Fade in={isVisible} {...(isVisible ? { timeout: 3000 } : {})}>
          <img
            ref={ref}
            src={bottomEffect}
            alt=""
            width="100%"
            style={{ position: "absolute", top: "0", left: "0" }}
          />
        </Fade>
        <div className="p-relative" style={{ zIndex: 1 }}>
          <Typography variant="h4" lineHeight={1} fontWeight="normal">
            Pre-built Foundation for Business to
          </Typography>
          <Typography variant="h2" lineHeight={1} my={1.5}>
            Create Owned Ecosystem
          </Typography>
          <Typography sx={{ textIndent: "40px" }}>
            On SIX Protocol, the business can create their own network by
            utilizing the “Sub-node” feature and use their own tokens as a key
            driver to the ecosystem.
          </Typography>

          <img
            src={eco1}
            alt=""
            width={lg ? "60%" : sm ? "80%" : "100%"}
            className="d-block mx-auto"
          />
        </div>
      </Section>
      <Section pt={4} pb="0" sx={{ position: "relative", zIndex: 1 }}>
        <div className="d-flex align-baseline flex-wrap">
          <Typography variant="h2" lineHeight={1} my={1.5} mr={2}>
            Friendly
          </Typography>
          <Typography variant="h4" lineHeight={1} fontWeight="normal">
            for Various Industries
          </Typography>
        </div>

        <Typography mb={md ? 8 : 4} mt={md ? 1.5 : 2}>
          No matter what industry or sector, SIX Protocol can be applied toyour
          business. Just define your business objective, SIX Protocol is ready
          to be used to achieve the goal as a backbone of the blockchain
          technology.
        </Typography>

        <div
          className={`d-flex align-center flex-wrap ${
            !md ? "flex-column-reverse" : ""
          }`}
        >
          <WhiteGradientButton
            sx={{ mt: { xs: 8, md: 0 } }}
            href="https://sixnetwork.gitbook.io/six-protocol/six-protocol/introduction"
            target="_blank"
          >
            LEARN MORE
          </WhiteGradientButton>
          <div
            className={`d-flex jusrify-center ${
              !md ? "col-12" : "col-6 ml-auto"
            }`}
          >
            <img
              src={eco2}
              alt=""
              width={lg ? "60%" : md ? "80%" : sm ? "40%" : "60%"}
              className="d-block mx-auto"
            />
          </div>
        </div>
      </Section>
    </>
  );
};

export default EcosystemSection;
